import { render } from "./input-tag.vue?vue&type=template&id=c7173908&scoped=true"
import script from "./input-tag.vue?vue&type=script&lang=js"
export * from "./input-tag.vue?vue&type=script&lang=js"

import "./input-tag.vue?vue&type=style&index=0&id=c7173908&lang=scss&scoped=true"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7173908"]])

export default __exports__